import src from "IMAGE";
export default { src, width: 1350, height: 360, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANElEQVR42i3LoQ0AIAwF0b8ACR4SCBAUGyCquv9KPVHxcuokaWGgweA46CjQxM0+fOwcawBLigJQjKllcwAAAABJRU5ErkJggg=="};
